<template>
  <div :class="classes" class="flex items-center select-none gap-x-2">
    <input
      :id="computedId"
      type="checkbox"
      class="checkbox mr-2"
      :class="checkboxClass"
      :checked="modelValue"
      @change="updateValue"
      @keydown.enter="updateValue"
      @blur="$emit('blur')"
      ref="checkbox"
      :disabled="disabled"
    />
    <label v-if="$slots.label || label" :for="computedId">
      <slot name="label">{{ label }}</slot>
    </label>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

// Props
const props = defineProps({
  modelValue: {
    type: Boolean,
    required: true
  },
  id: {
    type: String,
    default: null
  },
  label: {
    type: String,
    default: ''
  },
  disabled: {
    type: Boolean,
    default: false
  },
  inline: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: null
  },
  checkboxClass: {
    type: String,
  },
})

// Events
const emit = defineEmits(['blur', 'update:modelValue'])

// Refs and Computed
const checkbox = ref(null)

const classes = computed(() => {
  const classes = ['checkbox-container']
  if (props.disabled) classes.push('disabled')
  if (props.inline) classes.push('form-check-inline')
  if (props.type) classes.push('checkbox-' + props.type)
  return classes
})

const computedId = computed(() => {
  return props.id || `checkbox-id-${getRandomIntBetween(100000, 999999)}`
})

// Methods
function updateValue(event) {
  emit('update:modelValue', event.target.checked)
}

function getRandomIntBetween(min, max) {
  min = Math.ceil(min)
  max = Math.floor(max)
  return Math.floor(Math.random() * (max - min)) + min
}
</script>